import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { typingMessage } from "../../../../../ReduxToolkit/Reducers/Messenger/Chat";

const ChatLoader = () => {
  const { isTyping } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  const time = new Date().toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });

  useEffect(() => {
    setTimeout(() => dispatch(typingMessage(false)), 2000);
  }, [dispatch, isTyping]);
  return (
    <li className={`sent last typing-m ${isTyping ? "d-block" : "d-none"}`}>
      <div className="d-flex align-items-end">
        <div className="flex-grow-1">
          <div className="contact-name">
            <ul className="msg-box">
              <li>
                <h5>
                  <div className="type">
                    <div className="typing-loader" />
                  </div>
                </h5>
              </li>
            </ul>
            <h6>{time}</h6>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ChatLoader;
